// extracted by mini-css-extract-plugin
module.exports = {"root":"BasicCard_root__1g-hX","more":"BasicCard_more__p81aa","less":"BasicCard_less__w1OWn","middle":"BasicCard_middle__2xenO"};